/**
方法声明
*/
const token_key = 'veimia64ec81e64431e';
const service = 'https://veimia-user.qgergdv.com/'
function request(name, action, params = {}, token = '') {
  let url = service + name + '/' + action;
  return new Promise((resolve, reject) => {
    let xhr = XMLHttpRequest ? new XMLHttpRequest() : new window.ActiveXObject('Microsoft.XMLHTTP');
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          try {
            //获取数据
            var response = JSON.parse(xhr.responseText);
            if (response.code == 200) {
              resolve(response.data);
            }
          } catch (e) {
            reject(e);
          }
        }if( xhr.status == 401){
            removeCookie("token")
        } else {
          reject(new Error('Request was unsuccessful: ' + xhr.statusText));
        }
      }
      xhr.onerror = function () {
        reject(xhr.statusText);
      };
    };
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
    xhr.send(JSON.stringify(params));
  });
}

//获取时间戳
function getTimestamp() {
  return request('tools', 'getTimestamp');
}

function getToken(name, params) {
  return request(name, 'login', params);
}

//调取积分功能相关数据
async function scoresAjax(action, params = {}) {
  let name = 'third-integral';
  let token = getCookie('token');
  let obj = {
    platform: 'shopify',
    // timestamp,
    // token,
  };
  const email = localStorage.getItem('customerEmail')//getCookie('sib_customer_email');
  if (action !== 'get-all-coupon-code' && email) {
    params.thirdCustId = email;
  }
  obj = Object.assign(obj, params);
  if (!token || token == 'null') {
    const data = await getToken('third-auth', { ...obj, key:token_key, email });
    token = data.token;
    setCookie('token', data.token, 1439);
  }

  return request(name, action, obj, token);
}

var removeEleTimer = null;
function toastMessage(text) {
  var toastWraper = document.getElementsByClassName("toast-message");
  if(toastWraper.length){
    toastWraper[0].parentNode.removeChild(toastWraper[0]);
    clearTimeout(removeEleTimer);
  };
  var divEle = document.createElement("div");
  divEle.className="toast-message";
  divEle.innerHTML = `<div style="position:fixed;width:fit-content;height:fit-content;min-width:120px;top:50%;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,.5);color:#fff;border-radius:4px;text-align:center;padding:0.5em 1em;"><span>${text}</span></div>`
  document.body.appendChild(divEle);
  removeEleTimer = setTimeout(() => {
    divEle.parentNode.removeChild(divEle);
  }, 3000);
}

function setCookie(name, value, time, path) {
  var expires = '';
  if (time != '') {
    var date = new Date();
    date.setTime(date.getTime() + time * 60 * 1000);
    expires = ';expires=' + date.toGMTString();
  }
  document.cookie = name + '=' + value + expires;
}

//获取cookie
function getCookie(name) {
  var myname = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(myname) == 0) {
      return c.substring(myname.length, c.length);
    }
  }
  return '';
}

function removeCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}
